export default "__VITE_ASSET__BmdW02tt__"